import PropTypes from 'prop-types';

const WidgetPropTypes = {
  changeAnswerValue: PropTypes.func,
  errorChecking: PropTypes.func,
  index: PropTypes.number,
  onClick: PropTypes.func,
  questionsAndAnswers: PropTypes.object,
  shouldEnable: PropTypes.func,
  widget: PropTypes.string,
  analytics: PropTypes.object
};

export default WidgetPropTypes;
